const constants = {
    DEVICE_DISPLAY_NAME: 'THE Lobby',
};

Object.freeze(constants);

export { constants };
